/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EventCreateDTO } from '../models';
// @ts-ignore
import type { EventResponseDTO } from '../models';
// @ts-ignore
import type { EventSearchResponseDTO } from '../models';
// @ts-ignore
import type { EventUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageEventResponseDTO } from '../models';
// @ts-ignore
import type { SearchStatsResponseDTO } from '../models';
// @ts-ignore
import type { SearchSuggestionsResponseDTO } from '../models';
/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventApiV1EventsPost: async (eventCreateDTO: EventCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventCreateDTO' is not null or undefined
            assertParamExists('createEventApiV1EventsPost', 'eventCreateDTO', eventCreateDTO)
            const localVarPath = `/api/v1/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventApiV1EventsPost_1: async (eventCreateDTO: EventCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventCreateDTO' is not null or undefined
            assertParamExists('createEventApiV1EventsPost_1', 'eventCreateDTO', eventCreateDTO)
            const localVarPath = `/api/v1/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventApiV1EventsEventIdDelete: async (eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEventApiV1EventsEventIdDelete', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateMode !== undefined) {
                localVarQueryParameter['update_mode'] = updateMode;
            }

            if (occurrenceDate !== undefined) {
                localVarQueryParameter['occurrence_date'] = (occurrenceDate as any instanceof Date) ?
                    (occurrenceDate as any).toISOString() :
                    occurrenceDate;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventApiV1EventsEventIdDelete_2: async (eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEventApiV1EventsEventIdDelete_2', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (updateMode !== undefined) {
                localVarQueryParameter['update_mode'] = updateMode;
            }

            if (occurrenceDate !== undefined) {
                localVarQueryParameter['occurrence_date'] = (occurrenceDate as any instanceof Date) ?
                    (occurrenceDate as any).toISOString() :
                    occurrenceDate;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventApiV1EventsEventIdGet: async (eventId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventApiV1EventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventApiV1EventsEventIdGet_3: async (eventId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventApiV1EventsEventIdGet_3', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchStatsApiV1EventsSearchStatsGet: async (q: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getEventSearchStatsApiV1EventsSearchStatsGet', 'q', q)
            const localVarPath = `/api/v1/events/search/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchStatsApiV1EventsSearchStatsGet_4: async (q: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getEventSearchStatsApiV1EventsSearchStatsGet_4', 'q', q)
            const localVarPath = `/api/v1/events/search/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet: async (q: string, maxSuggestions?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet', 'q', q)
            const localVarPath = `/api/v1/events/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (maxSuggestions !== undefined) {
                localVarQueryParameter['max_suggestions'] = maxSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5: async (q: string, maxSuggestions?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5', 'q', q)
            const localVarPath = `/api/v1/events/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (maxSuggestions !== undefined) {
                localVarQueryParameter['max_suggestions'] = maxSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsApiV1EventsGet: async (startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (calendarIds) {
                localVarQueryParameter['calendar_ids'] = calendarIds;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsApiV1EventsGet_6: async (startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (calendarIds) {
                localVarQueryParameter['calendar_ids'] = calendarIds;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsApiV1EventsSearchGet: async (q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchEventsApiV1EventsSearchGet', 'q', q)
            const localVarPath = `/api/v1/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (calendarId !== undefined) {
                localVarQueryParameter['calendar_id'] = calendarId;
            }

            if (includeSuggestions !== undefined) {
                localVarQueryParameter['include_suggestions'] = includeSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsApiV1EventsSearchGet_7: async (q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchEventsApiV1EventsSearchGet_7', 'q', q)
            const localVarPath = `/api/v1/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (calendarId !== undefined) {
                localVarQueryParameter['calendar_id'] = calendarId;
            }

            if (includeSuggestions !== undefined) {
                localVarQueryParameter['include_suggestions'] = includeSuggestions;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventApiV1EventsEventIdPatch: async (eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEventApiV1EventsEventIdPatch', 'eventId', eventId)
            // verify required parameter 'eventUpdateDTO' is not null or undefined
            assertParamExists('updateEventApiV1EventsEventIdPatch', 'eventUpdateDTO', eventUpdateDTO)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventApiV1EventsEventIdPatch_8: async (eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEventApiV1EventsEventIdPatch_8', 'eventId', eventId)
            // verify required parameter 'eventUpdateDTO' is not null or undefined
            assertParamExists('updateEventApiV1EventsEventIdPatch_8', 'eventUpdateDTO', eventUpdateDTO)
            const localVarPath = `/api/v1/events/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventApiV1EventsPost(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventApiV1EventsPost(eventCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.createEventApiV1EventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventApiV1EventsPost_1(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventApiV1EventsPost_1(eventCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.createEventApiV1EventsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventApiV1EventsEventIdDelete(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventApiV1EventsEventIdDelete(eventId, updateMode, occurrenceDate, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.deleteEventApiV1EventsEventIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventApiV1EventsEventIdDelete_2(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventApiV1EventsEventIdDelete_2(eventId, updateMode, occurrenceDate, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.deleteEventApiV1EventsEventIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventApiV1EventsEventIdGet(eventId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventApiV1EventsEventIdGet(eventId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventApiV1EventsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventApiV1EventsEventIdGet_3(eventId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventApiV1EventsEventIdGet_3(eventId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventApiV1EventsEventIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventSearchStatsApiV1EventsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchStatsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventSearchStatsApiV1EventsSearchStatsGet(q, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventSearchStatsApiV1EventsSearchStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventSearchStatsApiV1EventsSearchStatsGet_4(q: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchStatsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventSearchStatsApiV1EventsSearchStatsGet_4(q, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventSearchStatsApiV1EventsSearchStatsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q, maxSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q, maxSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventsApiV1EventsGet(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventsApiV1EventsGet(startDate, endDate, calendarIds, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.listEventsApiV1EventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventsApiV1EventsGet_6(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventsApiV1EventsGet_6(startDate, endDate, calendarIds, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.listEventsApiV1EventsGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEventsApiV1EventsSearchGet(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEventsApiV1EventsSearchGet(q, limit, offset, calendarId, includeSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.searchEventsApiV1EventsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEventsApiV1EventsSearchGet_7(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEventsApiV1EventsSearchGet_7(q, limit, offset, calendarId, includeSuggestions, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.searchEventsApiV1EventsSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventApiV1EventsEventIdPatch(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventApiV1EventsEventIdPatch(eventId, eventUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.updateEventApiV1EventsEventIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventApiV1EventsEventIdPatch_8(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventApiV1EventsEventIdPatch_8(eventId, eventUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.updateEventApiV1EventsEventIdPatch_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventApiV1EventsPost(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.createEventApiV1EventsPost(eventCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new event in a calendar. Requires \'event:write\' permission.
         * @summary Create Event
         * @param {EventCreateDTO} eventCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventApiV1EventsPost_1(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.createEventApiV1EventsPost_1(eventCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventApiV1EventsEventIdDelete(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEventApiV1EventsEventIdDelete(eventId, updateMode, occurrenceDate, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
         * @summary Delete Event
         * @param {string} eventId 
         * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
         * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventApiV1EventsEventIdDelete_2(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEventApiV1EventsEventIdDelete_2(eventId, updateMode, occurrenceDate, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventApiV1EventsEventIdGet(eventId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.getEventApiV1EventsEventIdGet(eventId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific event by ID. Requires \'event:view\' permission.
         * @summary Get Event
         * @param {string} eventId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventApiV1EventsEventIdGet_3(eventId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.getEventApiV1EventsEventIdGet_3(eventId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchStatsApiV1EventsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchStatsResponseDTO> {
            return localVarFp.getEventSearchStatsApiV1EventsSearchStatsGet(q, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics for an event search query. Requires \'event:view\' permission.
         * @summary Get Event Search Stats
         * @param {string} q Search query
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchStatsApiV1EventsSearchStatsGet_4(q: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchStatsResponseDTO> {
            return localVarFp.getEventSearchStatsApiV1EventsSearchStatsGet_4(q, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchSuggestionsResponseDTO> {
            return localVarFp.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q, maxSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
         * @summary Get Event Search Suggestions
         * @param {string} q Partial search query
         * @param {number} [maxSuggestions] Maximum suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchSuggestionsResponseDTO> {
            return localVarFp.getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q, maxSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsApiV1EventsGet(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageEventResponseDTO> {
            return localVarFp.listEventsApiV1EventsGet(startDate, endDate, calendarIds, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
         * @summary List Events
         * @param {string | null} [startDate] Start date for event filtering (ISO format)
         * @param {string | null} [endDate] End date for event filtering (ISO format)
         * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventsApiV1EventsGet_6(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageEventResponseDTO> {
            return localVarFp.listEventsApiV1EventsGet_6(startDate, endDate, calendarIds, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsApiV1EventsSearchGet(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventSearchResponseDTO> {
            return localVarFp.searchEventsApiV1EventsSearchGet(q, limit, offset, calendarId, includeSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
         * @summary Search Events
         * @param {string} q Search query
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [calendarId] Filter by specific calendar
         * @param {boolean} [includeSuggestions] Include search suggestions
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsApiV1EventsSearchGet_7(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventSearchResponseDTO> {
            return localVarFp.searchEventsApiV1EventsSearchGet_7(q, limit, offset, calendarId, includeSuggestions, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventApiV1EventsEventIdPatch(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.updateEventApiV1EventsEventIdPatch(eventId, eventUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event\'s information. Requires \'event:write\' permission.
         * @summary Update Event
         * @param {string} eventId 
         * @param {EventUpdateDTO} eventUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventApiV1EventsEventIdPatch_8(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventResponseDTO> {
            return localVarFp.updateEventApiV1EventsEventIdPatch_8(eventId, eventUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Create a new event in a calendar. Requires \'event:write\' permission.
     * @summary Create Event
     * @param {EventCreateDTO} eventCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventApiV1EventsPost(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventApiV1EventsPost(eventCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new event in a calendar. Requires \'event:write\' permission.
     * @summary Create Event
     * @param {EventCreateDTO} eventCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventApiV1EventsPost_1(eventCreateDTO: EventCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventApiV1EventsPost_1(eventCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
     * @summary Delete Event
     * @param {string} eventId 
     * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
     * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventApiV1EventsEventIdDelete(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventApiV1EventsEventIdDelete(eventId, updateMode, occurrenceDate, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event with support for recurring event deletion modes.  Deletion modes: - single: Delete only the specified occurrence (adds to recurrence exceptions) - following: Delete this occurrence and all future occurrences (updates RRULE UNTIL) - series: Delete all occurrences of the recurring event (deletes parent event)  For \'single\' and \'following\' modes, occurrence_date must be provided.  Requires \'event:write\' permission.
     * @summary Delete Event
     * @param {string} eventId 
     * @param {string | null} [updateMode] Deletion mode: \&#39;single\&#39; (this occurrence), \&#39;following\&#39; (this and future), \&#39;series\&#39; (all occurrences)
     * @param {string | null} [occurrenceDate] The specific occurrence date to delete (required for \&#39;single\&#39; and \&#39;following\&#39; modes)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventApiV1EventsEventIdDelete_2(eventId: string, updateMode?: string | null, occurrenceDate?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventApiV1EventsEventIdDelete_2(eventId, updateMode, occurrenceDate, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific event by ID. Requires \'event:view\' permission.
     * @summary Get Event
     * @param {string} eventId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventApiV1EventsEventIdGet(eventId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventApiV1EventsEventIdGet(eventId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific event by ID. Requires \'event:view\' permission.
     * @summary Get Event
     * @param {string} eventId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventApiV1EventsEventIdGet_3(eventId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventApiV1EventsEventIdGet_3(eventId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics for an event search query. Requires \'event:view\' permission.
     * @summary Get Event Search Stats
     * @param {string} q Search query
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventSearchStatsApiV1EventsSearchStatsGet(q: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventSearchStatsApiV1EventsSearchStatsGet(q, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics for an event search query. Requires \'event:view\' permission.
     * @summary Get Event Search Stats
     * @param {string} q Search query
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventSearchStatsApiV1EventsSearchStatsGet_4(q: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventSearchStatsApiV1EventsSearchStatsGet_4(q, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
     * @summary Get Event Search Suggestions
     * @param {string} q Partial search query
     * @param {number} [maxSuggestions] Maximum suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet(q, maxSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get search suggestions for events based on partial query. Requires \'event:view\' permission.
     * @summary Get Event Search Suggestions
     * @param {string} q Partial search query
     * @param {number} [maxSuggestions] Maximum suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q: string, maxSuggestions?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventSearchSuggestionsApiV1EventsSearchSuggestionsGet_5(q, maxSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
     * @summary List Events
     * @param {string | null} [startDate] Start date for event filtering (ISO format)
     * @param {string | null} [endDate] End date for event filtering (ISO format)
     * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public listEventsApiV1EventsGet(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).listEventsApiV1EventsGet(startDate, endDate, calendarIds, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List events, optionally filtered by date range and calendar IDs. Requires \'event:view\' permission.
     * @summary List Events
     * @param {string | null} [startDate] Start date for event filtering (ISO format)
     * @param {string | null} [endDate] End date for event filtering (ISO format)
     * @param {Array<string> | null} [calendarIds] Filter by calendar IDs
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public listEventsApiV1EventsGet_6(startDate?: string | null, endDate?: string | null, calendarIds?: Array<string> | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).listEventsApiV1EventsGet_6(startDate, endDate, calendarIds, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
     * @summary Search Events
     * @param {string} q Search query
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [calendarId] Filter by specific calendar
     * @param {boolean} [includeSuggestions] Include search suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public searchEventsApiV1EventsSearchGet(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).searchEventsApiV1EventsSearchGet(q, limit, offset, calendarId, includeSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search events using full-text search and pattern matching. Supports natural language queries for titles, descriptions, locations, and event types. Requires \'event:view\' permission.
     * @summary Search Events
     * @param {string} q Search query
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [calendarId] Filter by specific calendar
     * @param {boolean} [includeSuggestions] Include search suggestions
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public searchEventsApiV1EventsSearchGet_7(q: string, limit?: number, offset?: number, calendarId?: string | null, includeSuggestions?: boolean, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).searchEventsApiV1EventsSearchGet_7(q, limit, offset, calendarId, includeSuggestions, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event\'s information. Requires \'event:write\' permission.
     * @summary Update Event
     * @param {string} eventId 
     * @param {EventUpdateDTO} eventUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventApiV1EventsEventIdPatch(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventApiV1EventsEventIdPatch(eventId, eventUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event\'s information. Requires \'event:write\' permission.
     * @summary Update Event
     * @param {string} eventId 
     * @param {EventUpdateDTO} eventUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventApiV1EventsEventIdPatch_8(eventId: string, eventUpdateDTO: EventUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventApiV1EventsEventIdPatch_8(eventId, eventUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

